import CodeIcon from '@mui/icons-material/Code';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import ShareIcon from '@mui/icons-material/Share';
import IconButton from '@mui/material/IconButton';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { appStore } from '../../../stores/AppStore';
import { viewerStore } from '../../../stores/ViewerStore';
import { trackViewerInteraction } from '../../../utils/telemetry/matomo';
import { useEmbed } from '../hooks/useEmbed';
import { useShare } from '../hooks/useShare';
import { useSnapshot } from '../hooks/useSnapshot';

export const AppBarMoreButton: React.FC = () => {
    const [t] = useTranslation();
    const { urlInfo } = appStore.useState(['urlInfo']);
    const [open, setOpen] = React.useState(false);
    const ref = React.useRef(null);
    const { viewerVisible } = viewerStore.useState(['viewerVisible']);

    const handleShare = useShare(urlInfo);
    const handleEmbed = useEmbed(urlInfo);
    const handleSnapshot = useSnapshot();

    const disabled: boolean = !viewerVisible;

    return (
        <>
            <IconButton
                ref={ref}
                sx={{ color: '#4F4F4F' }}
                onClick={() => setOpen(true)}
            >
                <MoreVertIcon />
            </IconButton>
            <Menu
                anchorEl={ref.current}
                open={open}
                onClose={() => setOpen(false)}
            >
                <MenuItem
                    onClick={() => {
                        trackViewerInteraction('Open Embed');
                        void handleShare();
                    }}
                    disabled={disabled}
                >
                    <ShareIcon style={{ color: '#868686' }} />
                    <ListItemText
                        primary={t('Share')}
                        sx={{ paddingLeft: '10px' }}
                    />
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        trackViewerInteraction('Open Embed');
                        void handleEmbed();
                    }}
                    disabled={disabled}
                >
                    <CodeIcon style={{ color: '#868686' }} />
                    <ListItemText
                        primary={t('Embed')}
                        sx={{ paddingLeft: '10px' }}
                    />
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        trackViewerInteraction('Snapshot');
                        void handleSnapshot();
                    }}
                    disabled={disabled}
                >
                    <PhotoCameraIcon style={{ color: '#868686' }} />
                    <ListItemText
                        primary={t('Snapshot')}
                        sx={{ paddingLeft: '10px' }}
                    />
                </MenuItem>
            </Menu>
        </>
    );
};

AppBarMoreButton.displayName = 'AppBarMoreButton';
